import { CraftEmergenceIcon } from '@/components/icons/craft-emergence-icon'
import { cn } from '@/lib/utils'

export function AuthHeader({ className }: Readonly<{ className?: string }>) {
  return (
    <header
      className={cn(
        'sticky top-0 z-10 flex h-[56px] w-full shrink-0 items-center justify-between bg-neutral-600 pl-5 pr-3',
        className,
      )}
    >
      <div className='flex items-center gap-4' data-gtmid='navbar-logo-link'>
        <div className='pt-1'>
          <CraftEmergenceIcon />
        </div>
      </div>
    </header>
  )
}
